import React from "react";
import { Stack, styled, TextField, Typography } from "@mui/material";

import vendor from "../../images/vendor.png";
import itemImg from "../../images/item.png";
import code from "../../images/code.png";
import price from "../../images/money.png";
import description from "../../images/description.png";
import quantity from "../../images/quantity.png";
import { getQty } from "../../utils/getQty";

const Input = styled("div")({
  border: "1px solid #4daf51",
  padding: "10px",
  borderRadius: "10px",
  boxShadow: "0px 3px 7px #4daf51",
  height: "70px",
});

function OutOfStock({ item }) {
  return (
    <Stack spacing={3}>
      <Typography variant="h4" sx={{ color: "#4EAF51" }}>
        Item Details
      </Typography>
      <Input>
        <TextField
          variant="standard"
          value={item?.name}
          name="name"
          label="Name"
          type="text"
          sx={{ width: "90%" }}
          InputProps={{ disableUnderline: true }}
        />
        <img width="50px" height="50px" src={itemImg} alt="img" />
      </Input>
      <Input>
        <TextField
          variant="standard"
          value={item?.description}
          name="name"
          label="Description"
          type="text"
          sx={{ width: "90%" }}
          InputProps={{ disableUnderline: true }}
        />
        <img width="50px" height="50px" src={description} alt="img" />
      </Input>
      <Input>
        <TextField
          variant="standard"
          value={getQty(item)?.qty}
          name="name"
          label="Quantity"
          type="text"
          sx={{ width: "90%" }}
          InputProps={{ disableUnderline: true }}
        />
        <img width="50px" height="50px" src={quantity} alt="img" />
      </Input>
      <Input>
        <TextField
          variant="standard"
          value={item?.itemCode || item?.itemId}
          name="name"
          label="Item Code"
          type="text"
          sx={{ width: "90%" }}
          InputProps={{ disableUnderline: true }}
        />
        <img width="50px" height="50px" src={code} alt="img" />
      </Input>
      <Stack direction="row" gap={3}>
        <Input>
          <TextField
            variant="standard"
            value={item?.costPrice}
            name="name"
            label="Cost Price"
            type="text"
            sx={{ width: "70%" }}
            InputProps={{ disableUnderline: true }}
          />
          <img width="50px" height="50px" src={price} alt="img" />
        </Input>
        <Input>
          <TextField
            variant="standard"
            value={item?.price}
            name="name"
            label="Sale Price"
            type="text"
            sx={{ width: "70%" }}
            InputProps={{ disableUnderline: true }}
          />
          <img width="50px" height="50px" src={price} alt="img" />
        </Input>
      </Stack>
      <Input>
        <TextField
          variant="standard"
          value={item?.vendor}
          name="name"
          label="Vendor"
          type="text"
          sx={{ width: "90%" }}
          InputProps={{ disableUnderline: true }}
        />
        <img width="50px" height="50px" src={vendor} alt="img" />
      </Input>
    </Stack>
  );
}

export default OutOfStock;
